import { ComponentChild, h } from 'preact'
import { PureComponent } from 'preact-compat'
import AlertComponent from '../../control-components/ui-components/AlertComponent'
import PrivateMessageTooltip from './more-options/PrivateMessageTooltip'
import ReportPrivateMessage from './more-options/ReportPrivateMessage'
import { fetchPhrase } from '../../libs/translationsUtils/phrase'
import { TranslationCategory } from '../../libs/translationsUtils/translations'

interface Props {
  messageId: number
  userId: number
  conversationUser: {
    id: number
    username: string
  }
  messageContent: string
  errorCallback: () => void
  canReport: boolean
  canDelete: boolean
  phrases: {
    delete: string
    errorMessage: string
  }
}

interface State {
  alertMessage?: string | ComponentChild
  showReportModal: boolean
}

class PrivateMessage extends PureComponent<Props, State> {
  constructor () {
    super()
    this.setAlertMessage = this.setAlertMessage.bind(this)
    this.unsetAlertMessage = this.unsetAlertMessage.bind(this)
    this.showReportModal = this.showReportModal.bind(this)
    this.hideReportModal = this.hideReportModal.bind(this)
  }

  async componentDidMount () {
    const phrases = [
      { module: 'Forum', key: 'privateMessages.conversation.reportButton' },
      { module: 'Forum', key: 'privateMessages.reportModal.title' },
      { module: 'Forum', key: 'privateMessages.reportModal.reasons.placeholder' },
      { module: 'Forum', key: 'privateMessages.reportModal.text' },
      { module: 'Forum', key: 'privateMessages.reportModal.sender' },
      { module: 'Forum', key: 'privateMessages.reportModal.message' },
      { module: 'Forum', key: 'privateMessages.reportModal.reasons' },
      { module: 'Forum', key: 'privateMessages.reportModal.reportButton' },
      { module: 'Forum', key: 'privateMessages.reportModal.cancelButton' },
      { module: 'Forum', key: 'privateMessages.reportModal.reasons.error' },
      { module: 'Forum', key: 'privateMessages.reportModal.error' },
      { module: 'Forum', key: 'privateMessages.reportSuccessModal.title' },
      { module: 'Forum', key: 'privateMessages.reportSuccessModal.text' },
      { module: 'Forum', key: 'privateMessages.reportSuccessModal.button' }
    ]
    await Promise.all(phrases.map(async p => await new Promise((resolve) => fetchPhrase(p.module as TranslationCategory, p.key, phrs => resolve(phrs)))))
  }

  setAlertMessage (message: string | ComponentChild) {
    this.setState({ alertMessage: message })
  }

  unsetAlertMessage () {
    this.setState({ alertMessage: undefined })
  }

  showReportModal () {
    this.setState({ showReportModal: true })
  }

  hideReportModal () {
    this.setState({ showReportModal: false })
  }

  render ({ messageId, messageContent, userId, conversationUser, canReport, canDelete, phrases }: Props, { alertMessage, showReportModal }: State) {
    const showTooltip = canReport || canDelete
    return (
      <div>
        {alertMessage &&
          <AlertComponent
            sticky
            isVisibleFor={3000}
            onTimeoutEnd={this.unsetAlertMessage}
          >
            {alertMessage}
          </AlertComponent>}
        {showTooltip &&
          <PrivateMessageTooltip
            messageId={messageId}
            messageContent={messageContent}
            userId={userId}
            conversationUser={conversationUser}
            canDelete={canDelete}
            setAlertMessage={this.setAlertMessage}
            phrases={phrases}
            onReport={this.showReportModal}
          />}
        {showReportModal &&
          <ReportPrivateMessage
            messageId={messageId}
            messageContent={messageContent}
            userId={userId}
            conversationUser={conversationUser}
            setAlertMessage={this.setAlertMessage}
            hideReportModal={this.hideReportModal}
          />}
      </div>
    )
  }
}

export default PrivateMessage
